import React, { useCallback, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { withRouter } from 'react-router'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'

// reactstrap components
import {
  Button,
  Container,
  Row,
  Col,
  Form,
  Input,
  FormGroup,
  Label,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
} from 'reactstrap'
import WhiteFooter from 'components/Footers/WhiteFooter.js'
import logoMural from 'assets/img/logo_mural_2.png'
import { UsersService } from 'services/users'
import ErrorText from 'components/Texts/ErrorText'
import Loading from 'components/Loading/Loading'
import { logout } from 'services/auth'

const schema = yup.object().shape({
  Nome: yup
    .string()
    .required('Por favor, preencha seu nome completo')
    .max(100, 'Limite máximo é de 100 caracteres')
    .nullable(),
  Email: yup.string().required('Por favor, preencha seu e-mail').max(50, 'Limite máximo é de 50 caracteres').nullable(),
  Senha: yup
    .string()
    .required('Por favor, preencha uma senha')
    .min(6, 'Mínimo permitido é de 6 caracteres')
    .max(15, 'Máximo permitido é de 15 caracteres')
    .nullable(),
})

const MeuPerfilPage = ({ history }) => {
  const [isLoading, setIsLoading] = useState(false)

  const { errors, register, handleSubmit, setValue } = useForm({ resolver: yupResolver(schema) })

  const onSubmit = useCallback(async (value) => {
    try {
      setIsLoading(true)
      const response = await UsersService.update(value)
      if (response.status === 200) {
        toast.success('Perfil salvo com sucesso!')
      }
    } catch (e) {
      toast.error(e?.response?.data || e.message)
    } finally {
      setIsLoading(false)
    }
  }, [])

  const goBack = useCallback(() => {
    history.push('/mural-aprovados-sisu')
  }, [history])

  const handleDeleteUser = useCallback(async () => {
    try {
      const confirm = window.confirm('Você tem certeza que deseja excluir o seu perfil?')
      if (confirm) {
        await UsersService.deleteUser()
        toast.success('Perfil excluído com sucesso!')
        logout()
        history.push('/#principal')
      }
    } catch (e) {
      toast.error(e?.response?.data || e.message)
    }
  }, [history])

  useEffect(() => {
    const getUser = async () => {
      setIsLoading(true)
      try {
        const response = await UsersService.getUserData()
        if (response.status === 200) {
          setValue('Nome', response.data.Nome)
          setValue('Email', response.data.Email)
          setValue('Celular', response.data.Celular)
          setValue('Estado', response.data.Estado)
          setValue('Cidade', response.data.Cidade)
          setValue('NomeEscola', response.data.NomeEscola)
        }
      } catch (e) {
      } finally {
        setIsLoading(false)
      }
    }

    getUser()
  }, [setValue])

  return (
    <>
      <div className="section">
        <Container className="text-center">
          <Row>
            <Col style={{ textAlign: 'end' }}>
              <Button onClick={goBack} className="btn-round" color="#000">
                <span>X</span>
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <img src={logoMural} style={{ width: 260 }} alt="" />
            </Col>
          </Row>
        </Container>

        <Container className="text-center">
          <h2
            className="title"
            style={{
              fontWeight: 600,
              letterSpacing: 2,
              marginTop: 30,
              fontSize: 32,
            }}
          >
            Meu Perfil
          </h2>

          <Form id="cadastro-form" onSubmit={handleSubmit(onSubmit)}>
            <div className="title-brand" style={{ marginTop: 40, letterSpacing: 2, fontSize: 16 }}>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText
                    style={{
                      borderRadius: 20,
                      marginRight: 10,
                      height: 45,
                      paddingLeft: 22,
                      paddingRight: 20,
                    }}
                  >
                    <i className="nc-icon nc-single-02" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  innerRef={register}
                  id="Nome"
                  name="Nome"
                  placeholder="Nome completo"
                  type="text"
                  style={{
                    borderRadius: 20,
                    height: 45,
                    paddingLeft: 20,
                    letterSpacing: 3,
                  }}
                />
              </InputGroup>
              <ErrorText errors={errors} name="Nome" />
            </div>

            <div className="title-brand" style={{ marginTop: 15, letterSpacing: 4, fontSize: 16 }}>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText
                    style={{
                      borderRadius: 20,
                      marginRight: 10,
                      height: 45,
                      paddingLeft: 22,
                      paddingRight: 20,
                    }}
                  >
                    <i className="nc-icon nc-email-85" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  innerRef={register}
                  id="Email"
                  name="Email"
                  placeholder="E-mail"
                  type="text"
                  style={{
                    borderRadius: 20,
                    height: 45,
                    paddingLeft: 20,
                    letterSpacing: 3,
                  }}
                />
              </InputGroup>
              <ErrorText errors={errors} name="Email" />
            </div>

            <div className="title-brand" style={{ marginTop: 15, letterSpacing: 4, fontSize: 16 }}>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText
                    style={{
                      borderRadius: 20,
                      marginRight: 10,
                      height: 45,
                      paddingLeft: 22,
                      paddingRight: 20,
                    }}
                  >
                    <i className="nc-icon nc-lock-circle-open" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  innerRef={register}
                  id="Senha"
                  name="Senha"
                  placeholder="Senha"
                  type="password"
                  style={{
                    borderRadius: 20,
                    height: 45,
                    paddingLeft: 20,
                    letterSpacing: 3,
                  }}
                />
              </InputGroup>
              <ErrorText errors={errors} name="Senha" />
            </div>

            <div className="title-brand" style={{ marginTop: 15, letterSpacing: 4, fontSize: 16 }}>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText
                    style={{
                      borderRadius: 20,
                      marginRight: 10,
                      height: 45,
                      paddingLeft: 22,
                      paddingRight: 20,
                    }}
                  >
                    <i className="nc-icon nc-mobile" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  innerRef={register}
                  disabled
                  id="Celular"
                  name="Celular"
                  placeholder="Celular"
                  type="text"
                  style={{
                    borderRadius: 20,
                    height: 45,
                    paddingLeft: 20,
                    letterSpacing: 3,
                  }}
                />
              </InputGroup>
            </div>

            <div className="title-brand" style={{ marginTop: 15, letterSpacing: 4, fontSize: 16 }}>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText
                    style={{
                      borderRadius: 20,
                      marginRight: 10,
                      height: 45,
                      paddingLeft: 22,
                      paddingRight: 20,
                    }}
                  >
                    <i className="nc-icon nc-map-big" />
                  </InputGroupText>
                </InputGroupAddon>

                <Input
                  innerRef={register}
                  disabled
                  id="Estado"
                  name="Estado"
                  placeholder="Estado"
                  type="text"
                  style={{
                    borderRadius: 20,
                    height: 45,
                    paddingLeft: 20,
                    letterSpacing: 3,
                  }}
                />
              </InputGroup>
            </div>

            <div className="title-brand" style={{ marginTop: 15, letterSpacing: 4, fontSize: 16 }}>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText
                    style={{
                      borderRadius: 20,
                      marginRight: 10,
                      height: 45,
                      paddingLeft: 22,
                      paddingRight: 20,
                    }}
                  >
                    <i className="nc-icon nc-bank" />
                  </InputGroupText>
                </InputGroupAddon>

                <Input
                  innerRef={register}
                  disabled
                  id="Cidade"
                  name="Cidade"
                  placeholder="Cidade"
                  type="text"
                  style={{
                    borderRadius: 20,
                    height: 45,
                    paddingLeft: 20,
                    letterSpacing: 3,
                  }}
                />
              </InputGroup>
            </div>

            <div className="title-brand" style={{ marginTop: 15, letterSpacing: 4, fontSize: 16 }}>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText
                    style={{
                      borderRadius: 20,
                      marginRight: 10,
                      height: 45,
                      paddingLeft: 22,
                      paddingRight: 20,
                    }}
                  >
                    <i className="nc-icon nc-shop" />
                  </InputGroupText>
                </InputGroupAddon>

                <Input
                  disabled
                  innerRef={register}
                  id="NomeEscola"
                  name="NomeEscola"
                  placeholder="Escola"
                  type="text"
                  style={{
                    borderRadius: 20,
                    height: 45,
                    paddingLeft: 20,
                    letterSpacing: 3,
                  }}
                />
              </InputGroup>
            </div>

            <div className="title-brand" style={{ marginTop: 20, letterSpacing: 4, fontSize: 16 }}>
              {isLoading ? (
                <Loading />
              ) : (
                <Button
                  type="submit"
                  className="btn-round"
                  color="danger"
                  style={{
                    paddingTop: 8,
                    paddingBottom: 5,
                    fontSize: 14,
                    letterSpacing: 4,
                    textTransform: 'none',
                    color: '#FFF',
                    border: 0,
                    width: '100%',
                    height: 45,
                    borderRadius: 20,
                  }}
                >
                  Salvar
                </Button>
              )}
            </div>

            <div className="title-brand" align="left" style={{ textAlign: 'start' }}>
              <FormGroup check style={{ justifyContent: 'start', paddingTop: 15 }}>
                <Label
                  style={{
                    color: '#000',
                    letterSpacing: 3,
                    fontSize: 12,
                    fontWeight: 400,
                  }}
                  check
                >
                  <Input disabled type="checkbox" checked="checked" style={{ color: '#000' }} /> Concordo com os Termos
                  de Uso e Política de Privacidade.
                  <span className="form-check-sign">
                    <span className="check"></span>
                  </span>
                </Label>
              </FormGroup>

              <div
                align="left"
                style={{
                  color: '#000',
                  letterSpacing: 4,
                  fontWeight: 400,
                  fontSize: 12,
                  marginTop: 30,
                  marginBottom: 30,
                }}
              >
                <a href="#!" style={{ color: '#E94B4B' }} onClick={handleDeleteUser}>
                  Excluir perfil
                </a>{' '}
                do Mural de Aprovados SiSU.
              </div>
            </div>
          </Form>
        </Container>

        <WhiteFooter />
      </div>
    </>
  )
}

export default withRouter(MeuPerfilPage)
